"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    cancel: 'בטל שינויים',
    confirm: 'אישור',
    close: 'סגירה',
    back: 'חזרה',
    save: 'שמור',
    finished: 'סיימתי',
    select: 'בחר',
    search: 'חפש',
    delete: 'מחק סביבה',
    required_field: 'שדה חובה',
    mainViewCreateTitle: 'יצירת סביבה',
    mainViewUpdateTitle: 'עדכון סביבה',
    mainViewDuplicateTitle: 'שכפול סביבה',
    schoolSelectionViewTitle: 'בחירת בית ספר',
    schoolSignPlaceholder: ' יש להזין סמל מוסד',
    schoolBySign: 'לפי סמל מוסד',
    schoolByName: 'לפי שם',
    school: 'בית ספר',
    settlement: 'יישוב',
    select_environment: 'בחירת סביבה',
    environment_name: 'שם הסביבה',
    environment_name_placeholder: "יש להזין שם לסביבה לדוגמה י'1 המורה מיכל",
    environment_edit_name: 'עריכת שם',
    teacher_operator: 'מי המורים בסביבה?',
    participants: 'מי התלמידים בסביבה?',
    participants_should_select_operator_teachers: 'יש לבחור לפחות מורה מפעיל אחד',
    schedule: 'לוח זמנים',
    schedule_start_text: 'תאריך התחלה',
    schedule_end_text: 'תאריך סיום',
    environment_duplicated_name_warning: 'למורה {} יש סביבה בשם זהה, מומלץ לשנותו.',
    environment_error: 'אירעה שגיאה. אנא נסו שנית.',
    environment_created: 'מעולה! הסביבה נוצרה.',
    environment_updated: 'מעולה! הסביבה עודכנה.',
    environment_ready_for_work: 'אפשר לחזור לעבוד בה עם התלמידים.',
    environment_invite_class: 'אפשר להתחיל לעבוד בה עם התלמידים.',
    create_another_environment: 'ליצירת סביבה נוספת',
    update_another_environment: 'לעדכון סביבה נוספת',
    start_work_on_environment: 'לכניסה לסביבה',
    share_env: 'קיבלת שיתוף לסביבה {X} - {Y}',
    share_Tooltip: 'שיתוף עם התלמידים להם שויכה הסביבה',
    environment_confirm_delete: 'האם ברצונך למחוק את הסביבה',
    environment_deleted: 'הסביבה נמחקה',
    environment_not_deleted: 'הסביבה לא נמחקה',
    environment_not_deleted_support: 'לידיעתכם, לא ניתן למחוק סביבה פעילה, לעזרה, אנא פנו למרכז התמיכה'
  },
  ar: {
    cancel: 'إلغاء',
    confirm: 'موافقة',
    close: 'إغلاق',
    back: 'عودة',
    save: 'حفظ',
    finished: 'أنهيت',
    select: 'اختيار',
    search: 'يطلب',
    delete: 'حذف بيئة تعليميّة',
    required_field: 'خانة إلزاميّة',
    mainViewCreateTitle: 'خلق بيئة تعليمية',
    mainViewUpdateTitle: 'تحديث البيئة التعليمية',
    mainViewDuplicateTitle: 'تكرار البيئة التعليمية',
    schoolSelectionViewTitle: 'اختيار المدرسة',
    schoolSignPlaceholder: 'رمز المدرسة',
    schoolBySign: 'رمز المدرسة',
    schoolByName: 'اسم المدرسة',
    school: 'مدرسة',
    settlement: 'بلدة',
    select_environment: 'اختيار البيئة',
    environment_name: 'اسم البيئة التعليمية',
    environment_name_placeholder: 'يجب تسجيل اسم للبيئة، مثلًا العاشر 1 المعلّمة عرين',
    environment_edit_name: 'تحرير الاسم',
    teacher_operator: 'المعلّم/ ة المشغّل/ة',
    participants: 'المشاركون',
    participants_should_select_operator_teachers: 'يجب اختيار معلم واحد على الأقل',
    schedule: 'الجدول الزمنيّ',
    schedule_start_text: 'تاريخ البدء',
    schedule_end_text: 'تاريخ الإنهاء',
    environment_duplicated_name_warning: 'للمعلّم {} هناك بيئة تحمل نفس الاسم. ننصح بتغيير الاسم.',
    environment_error: 'وقع خلل، الرجاء المحاولة لاحقًا',
    environment_created: 'عظيم! تم إنشاء بيئة تعليمية.',
    environment_updated: 'عظيم! تم تحديث البيئة التعليمية.',
    environment_ready_for_work: 'يمكنك العودة للعمل عليه مع الطلاب.',
    environment_invite_class: 'يمكنك بدء العمل فيها مع التلاميذ.',
    create_another_environment: 'لإضافة بيئة تعليميّة أخرى',
    update_another_environment: 'تحديث بيئة تعليمية أخرى',
    start_work_on_environment: 'للدخول إلى البيئة',
    share_env: 'تمّت مشاركتك في البيئة التعليميّة {X} - {Y}',
    share_Tooltip: 'شارك مع الطلاب',
    environment_confirm_delete: 'هل تريد حذف البيئة التعليميّة',
    environment_deleted: 'הסביבה נמחקה',
    environment_not_deleted: 'הסביבה לא נמחקה',
    environment_not_deleted_support: 'לידיעתכם, לא ניתן למחוק סביבה פעילה, לעזרה, אנא פנו למרכז התמיכה'
  },
  en: {
    cancel: 'Cancel',
    confirm: 'Next',
    close: 'Close',
    back: 'Back',
    save: 'Save',
    finished: 'Done',
    select: 'Select',
    search: 'Search',
    delete: 'Delete environment',
    required_field: 'Required field',
    mainViewCreateTitle: 'Create Environment',
    mainViewUpdateTitle: 'Update Environment',
    mainViewDuplicateTitle: 'Duplicate Environment',
    schoolSelectionViewTitle: 'School selection',
    schoolSignPlaceholder: 'Insert school symbol',
    schoolBySign: 'By symbol',
    schoolByName: 'By name',
    school: 'School',
    settlement: 'Settlement',
    select_environment: 'Select environment',
    environment_name: 'Environment name',
    environment_name_placeholder: 'Enter an environment name (for example, 10/1 Teacher - Michal)',
    environment_edit_name: 'Edit name',
    teacher_operator: 'Teachers',
    participants: 'Participants',
    participants_should_select_operator_teachers: 'Plesae select at least one operator teacher',
    schedule: 'Schedule',
    schedule_start_text: 'Start date',
    schedule_end_text: 'End date',
    environment_duplicated_name_warning: 'Attention: for teacher {} there is an existing environment with the same name, changing it is recommended.',
    environment_error: 'An error has occurred. Please try again.',
    environment_created: 'Great! The learning environment is now assigned to your students.',
    environment_updated: 'Great! The learning environment has been updated.',
    environment_ready_for_work: 'You can now continue working with your students.',
    environment_invite_class: 'You can now begin working with your students.',
    create_another_environment: 'Create another environment',
    update_another_environment: 'Update another environment',
    start_work_on_environment: 'Enter the environment',
    share_env: 'The learning environment {X} has been shared with you',
    share_Tooltip: 'share with the assigned students',
    environment_confirm_delete: 'Do you want to delete the environment',
    environment_deleted: 'The environment was deleted',
    environment_not_deleted: 'The environment was not deleted',
    environment_not_deleted_support: 'For your information, it is not possible to delete an active environment, for help, please contact the support center'
  }
};